// src/lib/usd.js — cents (integer) → "$12.34". The balance is US cents shown
// as USD; there is no other unit. Plain ESM (Deno-tested through its users).

export function formatUsd(cents) {
  const n = Number(cents);
  if (cents === null || cents === undefined || !Number.isFinite(n)) return '$—';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(Math.round(n));
  return `${sign}$${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, '0')}`;
}
